import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';

@Component({
    templateUrl: 'alert.details.modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertDetailsModalComponent
    extends UiModalComponent<any> {
}
